<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0">
        <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <div class="d-sm-flex align-items-center">
                <h5 class="fw-medium text-black-emphasis mb-0">{{ $t('feature.roles.centers_permissions') }}</h5>
            </div>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
            <!-- <div class="mb-15 d-sm-flex align-items-center justify-content-between">
                <h5 class="fw-medium text-black-emphasis mb-0">{{ $t('feature.roles.centers_permissions') }}</h5>
            </div> -->
            <SpinnerLoading v-if="centers === undefined || permissions === undefined" />
            <div class="table-responsive" v-else>
                <table class="table text-nowrap align-middle mb-0">
                    <thead>
                        <tr>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">

                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                v-for="action in actions" :key="action">
                                {{ $t(`feature.roles.$permissions.${action}`) }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- PERMISSION ROW -->
                        <tr v-for="center in centers" :key="center.id">
                            <th class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0 pe-10">
                                <div class="d-flex align-items-center justify-content-start">
                                    {{ center.name }}
                                </div>
                            </th>
                            <!-- ACTIONS -->
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis" v-for="action in actions"
                                :key="action">
                                <div class="form-check form-check-primary">
                                    <input class="form-check-input shadow-none" type="checkbox"
                                        v-on:change="updateRolePermission(center, action)"
                                        :id="`${center.id}-${id}-${action}`" v-model="center.role_permissions[action]">
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import API from "@/services/api/api.service";
import { RolePermission } from '@/utils/models/user.model';
import SpinnerLoading from '@/components/Widgets/Spinner.vue';
import { CenterInfoWithPermissions } from '@/utils/models/center.model';
import { PERMISSION_ACTIONS } from '@/utils/const/permission_actions';

export default defineComponent({
    name: "RolePermission",
    data() {
        return {
            permissions: undefined as RolePermission[] | undefined,
            centers: undefined as CenterInfoWithPermissions[] | undefined,
            actions: PERMISSION_ACTIONS,
        }
    },
    props: {
        id: {
            type: [String, Number],
            required: true
        }
    },
    methods: {
        loadPermissions() {
            Promise.all([API.getRolePermissions(this.$props.id), API.getCenters()]).then((responses) => {
                this.permissions = responses[0]?.data?.data ?? [];
                this.centers = responses[1]?.data?.data ?? [];
                this.centers?.forEach((center) => {
                    let permission = this.permissions?.find((el) => el.center_id === center.id);
                    center.role_permissions = permission ?? {
                        role_id: this.id,
                        center_id: center.id,
                        index: false,
                        show: false,
                        destroy: false,
                        update: false,
                        store: false,
                    } as RolePermission;
                });
            });
        },
        updateRolePermission(center: CenterInfoWithPermissions, action: string) {
            API.updateRolePermissions(center.role_permissions).then((response) => {
                if (response.data.success === false) {
                    center.role_permissions[action] = !center.role_permissions[action];
                }
            }).catch((error) => {
                center.role_permissions[action] = !center.role_permissions[action];
            });
        }
    },
    mounted() {
        this.loadPermissions();
    },
    components: {
        SpinnerLoading
    }
});
</script>